// extracted by mini-css-extract-plugin
export default {"base":"ugoS1","table":"h8IcU","tableSecondary":"b1Z4m","solutionColumn":"es5zT","editColumn":"U6IM2","collectionColumn":"EO7xa","filterBar":"ZpynK","search":"bW8V_","filter":"hq5Au"};